import { api } from "../Apis/interceptor";
import axios from "axios";

export const verifyToken = async function () {
  try {
    // Make the API request to verify the token. The token is automatically sent via cookies.
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/verifyToken`, {
      withCredentials: true // Ensures cookies are sent with the request
    });

    // If the response status is 200 and the token is valid
    if (response.status === 200 && response.data.status) {
      return {
        success: true,
        message: response.data.message,  // 'Token is valid'
        decoded: response.data.decoded  // Optionally, store or use the decoded data
      };
    } else {
      return {
        success: false,
        message: response.data.message || 'Token verification failed'
      };
    }
  } catch (error) {
    if (error.response) {
      // If the server returns a response with status 401 or 403
      if (error.response.status === 401 || error.response.status === 403) {
        // Clear Local Storage
        localStorage.clear()
        // Check if already on the /login page
          if (window.location.pathname !== '/login') {
            // Redirect to the login page and replace the current history entry
            window.location.replace('/login');
        }
      }

      // Return the status and message from the backend response
      return {
        success: false,
        message: error.response.data.message || 'Error verifying token: ' + error.message
      };
    } else {
      return {
        success: false,
        message: 'Network error or no response from the server'
      };
    }
  }
};

export const getToken = async function () {
  const credentials = localStorage.getItem("credentials");
  if(credentials){
    const username = JSON.parse(credentials);
  if (username !== undefined && username !== null) {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/api/v1/getToken/` + username
    ); // Endpoint to get the token
    if (response.data.success) {
      return response.data.token;
    } 
  }
  }
  
};


export const loginCrdential = async (data) => {
  try {
    const res = await api.post("/api/v1/authenticate", data, {credentials: true});
    return res.data;
  } catch (err) {
    if (err) {
      console.log("err", err);
    }
  }
};

export const setLogoutTime = function (username) {
  // Remove cookie - logout superset user
  document.cookie =
    "session" +
    "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=" +
    ".myconsole.co.uk";
  return api.put("/api/v1/setLogoutTime", { username: username });
};

export const getUser = async () => {
  const isTokenValid = await verifyToken()
  if (isTokenValid.success) {
    return api.get("/api/v1/self");
  } else {
    return false;
  }
};

export const responseError = function (response) {
  if (response.status === 403) {
    if (response.data.isExpired) {
      localStorage.removeItem("token");
      setTimeout(function () {
        window.location.href = "/login";
      }, 1000);
    }
  }
  return new Promise((resolve, reject) => {
    Promise.reject(response);
  });
};
